// הממשק היחיד באפליקציה ל-Notification API של הדפדפן.
// בקשת ההרשאה עצמה (requestNotificationPermission) נקראת ממקום אחד בלבד — מסך ה-Login,
// אחרי התחברות מוצלחת ולפני setAuth (שמפעיל את זרימת WonderPush).

export function getNotificationPermission() {
  // Safari ב-iOS שלא מותקן למסך הבית (ודפדפנים ישנים) לא מגדירים Notification בכלל
  if (typeof window === 'undefined' || !('Notification' in window)) return 'unsupported'
  return Notification.permission // 'granted' | 'default' | 'denied'
}

// חייב להיקרא סינכרונית מתוך לחיצה של המשתמש (user gesture) —
// פיירפוקס / ספארי / PWA ב-iOS לא מציגים את חלון ההרשאה אחרת.
export function requestNotificationPermission() {
  if (getNotificationPermission() === 'unsupported') return Promise.resolve('unsupported')
  return new Promise((resolve) => {
    try {
      // ספארי ישן תומך רק ב-callback; דפדפנים חדשים מחזירים Promise (resolve כפול לא מזיק)
      const maybePromise = Notification.requestPermission(resolve)
      if (maybePromise && typeof maybePromise.then === 'function') maybePromise.then(resolve)
    } catch (e) {
      resolve(getNotificationPermission())
    }
  })
}
